<template>
  <div class="table-responsive scrollable-div Custom_Scrollbar">
    <table class="table" style="margin-bottom: 0;">
      <thead>
        <tr>
          <th
            class="lock hoverable"
            @click="$emit('changeSort', 'symbol')"
            style="z-index: 5;"
          >
            {{ $t('screener.table.symbol') }}
            <help-button
              :title="$t('screener.table.symbol')"
              :content="$t('screener.help.symbol')"
            />{{ ' ' }}
            <sort :status="sorts['symbol']" />
          </th>
          <th class="hoverable" @click="$emit('changeSort', 'companyName')">
            {{ $t('screener.table.companyName') }}
            <help-button
              :title="$t('screener.table.companyName')"
              :content="$t('screener.help.companyName')"
            />{{ ' ' }}
            <sort :status="sorts['companyName']" />
          </th>
          <th class="hoverable" @click="$emit('changeSort', 'currentPrice')">
            {{ $t('screener.table.currentPrice') }}
            <help-button
              :title="$t('screener.table.currentPriceL')"
              :content="$t('screener.help.currentPrice')"
            />{{ ' ' }}
            <sort :status="sorts['currentPrice']" />
          </th>
          <th
            class="hoverable"
            @click="$emit('changeSort', 'deriviatives.changePercent')"
          >
            {{ $t('screener.table.deriviatives.changePercent') }}
            <help-button
              :title="$t('screener.table.deriviatives.changePercentL')"
              :content="$t('screener.help.deriviatives.changePercent')"
            />{{ ' ' }}
            <sort :status="sorts['deriviatives.changePercent']" />
          </th>
          <th
            class="hoverable"
            @click="$emit('changeSort', 'fundamentalPrice')"
          >
            {{ $t('screener.table.fundamentalPrice') }}
            <help-button
              :title="$t('screener.table.fundamentalPriceL')"
              :content="$t('screener.help.fundamentalPrice')"
            />{{ ' ' }}
            <sort :status="sorts['fundamentalPrice']" />
          </th>
          <th
            class="hoverable"
            @click="$emit('changeSort', 'deriviatives.fundDiff')"
          >
            {{ $t('screener.table.deriviatives.fundDiff') }}
            <help-button
              :title="$t('screener.table.deriviatives.fundDiff')"
              :content="$t('screener.help.deriviatives.fundDiff')"
            />{{ ' ' }}
            <sort :status="sorts['deriviatives.fundDiff']" />
          </th>
          <template v-if="activeMode === 'common'">
            <th
              class="hoverable"
              @click="$emit('changeSort', 'deriviatives.perfDivSum12m')"
            >
              {{ $t('screener.table.deriviatives.perfDivSum12m') }}
              <help-button
                :title="$t('screener.table.deriviatives.perfDivSum12mL')"
                :content="$t('screener.help.deriviatives.perfDivSum12m')"
              />{{ ' ' }}
              <sort :status="sorts['deriviatives.perfDivSum12m']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'deriviatives.cap')"
            >
              {{ $t('screener.table.deriviatives.cap') }}
              <help-button
                :title="$t('screener.table.deriviatives.cap')"
                :content="$t('screener.help.deriviatives.cap')"
              />{{ ' ' }}
              <sort :status="sorts['deriviatives.cap']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'deriviatives.meanVol')"
            >
              {{ $t('screener.table.deriviatives.meanVol') }}
              <help-button
                :title="$t('screener.table.deriviatives.meanVolL')"
                :content="$t('screener.help.deriviatives.meanVol')"
              />{{ ' ' }}
              <sort :status="sorts['deriviatives.meanVol']" />
            </th>
            <th></th>
            <th>
              {{ $t('screener.table.w52') }}
              <help-button
                :title="$t('screener.table.w52')"
                :content="$t('screener.help.w52')"
              />
            </th>
            <th></th>
          </template>
          <template v-if="activeMode === 'dividends'">
            <!-- Сумма Див. 12м |	Див. Дох. 12м |	След. Див. | След. Див. Дох. | След. Див. Дата |	След. Див. Статус |	Див. Политика -->
            <!-- divSum12m | deriviatives.perfDivSum12m | nearestDiv.dividend | deriviatives.perfNearestDiv | nearestDiv.lastDivDay | nearestDiv.status | dividendPolitics -->
            <th class="hoverable" @click="$emit('changeSort', 'divSum12m')">
              {{ $t('screener.table.divSum12m') }}
              <help-button
                :title="$t('screener.table.divSum12mL')"
                :content="$t('screener.help.divSum12m')"
              />{{ ' ' }}
              <sort :status="sorts['divSum12m']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'deriviatives.perfDivSum12m')"
            >
              {{ $t('screener.table.deriviatives.perfDivSum12m') }}
              <help-button
                :title="$t('screener.table.deriviatives.perfDivSum12mL')"
                :content="$t('screener.help.deriviatives.perfDivSum12m')"
              />{{ ' ' }}
              <sort :status="sorts['deriviatives.perfDivSum12m']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'nearestDiv.dividend')"
            >
              {{ $t('screener.table.dividend') }}
              <help-button
                :title="$t('screener.table.dividendL')"
                :content="$t('screener.help.dividend')"
              />{{ ' ' }}
              <sort :status="sorts['nearestDiv.dividend']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'deriviatives.perfNearestDiv')"
            >
              {{ $t('screener.table.deriviatives.perfNearestDiv') }}
              <help-button
                :title="$t('screener.table.deriviatives.perfNearestDivL')"
                :content="$t('screener.help.deriviatives.perfNearestDiv')"
              />{{ ' ' }}
              <sort :status="sorts['deriviatives.perfNearestDiv']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'nearestDiv.lastDivDay')"
            >
              {{ $t('screener.table.lastDivDay') }}
              <help-button
                :title="$t('screener.table.lastDivDayL')"
                :content="$t('screener.help.lastDivDay')"
              />{{ ' ' }}
              <sort :status="sorts['nearestDiv.lastDivDay']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'nearestDiv.status')"
            >
              {{ $t('screener.table.status') }}
              <help-button
                :title="$t('screener.table.statusL')"
                :content="$t('screener.help.status')"
              />{{ ' ' }}
              <sort :status="sorts['nearestDiv.status']" />
            </th>
            <th
              class="hoverable"
              @click="$emit('changeSort', 'dividendPolitics')"
            >
              {{ $t('screener.table.dividendPolitics') }}
              <help-button
                :title="$t('screener.table.dividendPoliticsL')"
                :content="$t('screener.help.dividendPolitics')"
              />{{ ' ' }}
              <sort :status="sorts['dividendPolitics']" />
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="row.id"
          v-observe-visibility="visibilityChanged(row)"
          @click="$emit('rowclick', row)"
        >
          <td class="lock">{{ row.symbol }}</td>
          <td>
            {{
              row[`companyName_${$i18n.locale}`] ||
                row.companyName | shortText(21, '…')
            }}{{ getTickerType(row.tickerType, row.tickerTypeVisible) }}
          </td>
          <td
            :class="{
              red: row.directionDown !== undefined && row.directionDown,
              green: row.directionUp !== undefined && row.directionUp,
            }"
          >
            {{ row.currentPrice | financial(row.digitsAfterDot || 2) }}
          </td>
          <td :style="{ color: row.deriviatives.colors.changePercent }">
            {{ row.deriviatives.changePercent }}%
          </td>
          <template v-if="row.priceUnderReview">
            <td>{{ $t('header.market.underReview') }}</td>
            <td>{{ $t('header.market.underReview') }}</td>
          </template>
          <template v-else>
            <td>{{ row.fundamentalPrice }}</td>
            <td :style="{ color: row.deriviatives.colors.fundDiff }">
              {{ row.deriviatives.fundDiff }}%
            </td>
          </template>
          <template v-if="activeMode === 'common'">
            <td>{{ row.deriviatives.perfDivSum12m | financial(2) }}%</td>
            <td>{{ row.deriviatives.cap | getCap(row.currency) }}</td>
            <td>{{ row.deriviatives.meanVol | getCap(row.currency) }}</td>
            <td class="gr-l">{{ row.metrics52W ? row.metrics52W.l : '--' }}</td>
            <td class="px-0">
              <graph
                v-if="row.metrics52W"
                :l="row.metrics52W.l"
                :h="row.metrics52W.h"
                :c="row.metrics52W.c"
              />
            </td>
            <td class="gr-r">
              {{ row.metrics52W ? row.metrics52W.h : '--' }}
            </td>
          </template>
          <template v-if="activeMode === 'dividends'">
            <!-- Сумма Див. 12м |	Див. Дох. 12м |	След. Див. | След. Див. Дох. | След. Див. Дата |	След. Див. Статус |	Див. Политика -->
            <!-- divSum12m | deriviatives.perfDivSum12m | nearestDiv.dividend | deriviatives.perfNearestDiv | nearestDiv.lastDivDay | nearestDiv.status | dividendPolitics  -->
            <td>{{ row.divSum12m | financial(2) }}</td>
            <td>{{ row.deriviatives.perfDivSum12m | financial(2) }}%</td>
            <template v-if="row.nearestDiv && row.nearestDiv.status">
              <td>
                {{ row.nearestDiv.dividend | financial(2) }}
              </td>
              <td>{{ row.deriviatives.perfNearestDiv | financial(2) }}%</td>
              <td>{{ row.nearestDiv.lastDivDay }}</td>
              <td>{{ statusMap(row.nearestDiv.status) }}</td>
            </template>
            <template v-else>
              <td>--</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </template>
            <td><icon-boolean :val="row.dividendPolitics" /></td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import _ from 'lodash'
import filters from '@/utils/filters'
import { statusMap, periodMap } from '@/utils/dividends'

import Graph from './ScreenerGraph'
import SortSpan from './SortSpan'
import IconBoolean from '../icons/boolean'
import HelpButton from './HeaderHelpButton'

export default {
  props: {
    rows: Array,
    sorts: Object,
    activeMode: String,
  },
  data() {
    return {
      nowVisible: {},
    }
  },
  methods: {
    visibilityChanged(row) {
      if (!this.visibilityChangedFuncs) this.visibilityChangedFuncs = {}
      if (!this.visibilityChangedFuncs[row.symbol]) {
        this.visibilityChangedFuncs[row.symbol] = _.debounce((isVisible) => {
          this.changeVisibility(row, isVisible)
        }, 1000)
      }

      return this.visibilityChangedFuncs[row.symbol]
    },
    changeVisibility(row, isVisible) {
      if (!isVisible) {
        try {
          delete this.nowVisible[row.symbol]
        } catch {
          //
        }
      } else this.nowVisible[row.symbol] = isVisible
      this.$emit('visibilityChanged', {
        ticker: _.isString(row.symbol) ? row.symbol : row.ticker,
        visible: isVisible,
      })
    },
    unsubscribeAll() {
      while (_.keys(this.nowVisible).length > 0) {
        this.changeVisibility(
          {
            symbol: _.keys(this.nowVisible)[0],
          },
          false
        )
      }
    },
    getTickerType(tt, visible) {
      if (tt && visible) {
        return ' ' + this.$t('tickerTypes.' + tt)
      }
      return ''
    },
    statusMap,
    periodMap,
  },
  filters: {
    financial: filters.financial,
    getCap: filters.getCap,
    shortText: filters.shortText,
  },
  components: {
    graph: Graph,
    sort: SortSpan,
    'icon-boolean': IconBoolean,
    'help-button': HelpButton,
  },
}
</script>

<style lang="scss">
.screener .table {
  th,
  td {
    &.lock {
      background-color: #fff;
      transition: none !important;
      z-index: 2;
    }
    & span.sort {
      position: relative;
      bottom: 1.5px;
    }
  }
  th {
    background-color: #fff;
    border-bottom: none;
    z-index: 2;
    white-space: nowrap;
    vertical-align: middle;
  }
}
.screener {
  .scrollable-div {
    // overflow-y: scroll;
    // max-height: 80vh;
    margin-top: 12px;
    margin-bottom: 1rem;
  }
}

.table {
  // margin-top: 12px;
  th {
    color: #8a8a8a;
    border-top: none;
    padding: 12px 9px;
    font-family: 'PT Sans';
    font-style: normal;
    font-weight: normal;
    font-kerning: none;
    font-size: 0.75rem;
    line-height: 1rem;
    font-feature-settings: 'liga' off;
    box-shadow: inset 0px -2px 0px #000000;
    white-space: nowrap;

    &.hoverable:hover {
      cursor: pointer;
    }
  }
  td {
    font-family: PT Sans Caption;
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1rem;
    font-feature-settings: 'liga' off;
    padding: 12px 9px;
    align-self: center;
    transition: background-color 2s ease-in-out;
    white-space: nowrap;

    &.gr-l {
      color: #8a8a8a;
      text-align: right;
      right: -1px;
      position: relative;
    }
    &.gr-r {
      color: #8a8a8a;
      left: -1px;
      position: relative;
    }
    &:hover {
      cursor: pointer;
    }
    &.red {
      background-color: rgba(237, 80, 81, 0.8);
      transition: background-color 0.1s ease-in;
    }
    &.green {
      background-color: rgba(8, 182, 77, 0.8);
      transition: background-color 0.1s ease-in;
    }
  }

  $tableColumnWidth: 5rem;
  th,
  td {
    // &:nth-child(2) {
    //   padding-left: $tableColumnWidth;
    // }
    &.lock {
      // position: absolute;
      // left: auto;
      // top: auto;
      position: sticky;
      left: 0;
      // background-color: white;
      width: $tableColumnWidth;
    }
  }
}
</style>
